import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setArticles } from "../../redux";

import { LangContext } from "../../context/LangContext";
import { useGoPage } from "../../hooks/useGoPage";

import SelectLang from "../../components/SelectLang";
import ConfirmDelete from "../../components/ConfirmDelete";

import "./style.css"

function Shop() {
    const goPage = useGoPage();
    const dispatch = useDispatch();

    const articlesList = useSelector(state => state.articles);
    const { language } = useContext(LangContext);

    const [toDelete, setToDelete] = useState(null);

    const switchLeft = async (article) => {
        if (article.order === articlesList.length - 1) return
        const nextArticle = articlesList.find(i => i.order === article.order + 1);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/order/${article._id}/${nextArticle._id}`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        if (req.status !== 200) return alert(res.message);

        const newArticlesList = articlesList.map(item => {
            if (item._id === article._id) {
                return { ...item, order: item.order + 1 };
            }
            else if (item._id === nextArticle._id) {
                return { ...item, order: item.order - 1 };
            }
            return item;
        });
        newArticlesList.sort((a, b) => a.order - b.order);
        dispatch(setArticles(newArticlesList))
    };

    const switchRight = async (article) => {
        if (article.order === 0) return
        const prevArticle = articlesList.find(i => i.order === article.order - 1);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/order/${article._id}/${prevArticle._id}`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        if (req.status !== 200) return alert(res.message);

        const newArticlesList = articlesList.map(item => {
            if (item._id === article._id) {
                return { ...item, order: item.order - 1 };
            }
            else if (item._id === prevArticle._id) {
                return { ...item, order: item.order + 1 };
            }
            return item;
        });
        newArticlesList.sort((a, b) => a.order - b.order);
        dispatch(setArticles(newArticlesList))
    };

    const deleteArticle = async () => {
        const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/del/${toDelete._id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();

        if (req.status !== 200) {
            alert(res.message);
            setToDelete(null);
            return
        }

        const newArticleList = articlesList.filter(i => i._id !== toDelete._id);
        dispatch(setArticles(newArticleList));

        alert("L'oeuvre a bien été supprimé !");
        setToDelete(null);
    }

    return (
        <div className='page page_shop'>
            <p className='title_page'>
                - <span>Shop</span> -
            </p>

            <SelectLang />

            <button
                className="btn_new_item"
                onClick={() => goPage('article/newarticle')}
            >
                + Nouvelle oeuvre
            </button>

            {articlesList &&
                <ul className="articles_list">
                    {articlesList.length !== 0 && articlesList.map((artcl, idx) => (
                        <li key={idx}>
                            <button
                                className="onglet"
                                onClick={() => goPage(`article/${artcl.title_path}`)}
                            >
                                <div className="preview">
                                    <i style={{ backgroundImage: `url(${artcl.images[0]._url})` }}></i>
                                </div>

                                <h2>- {artcl[`title_${language}`]} -</h2>
                            </button>

                            {idx !== articlesList.length - 1 &&
                                <button
                                    className="btn_right btn_panel"
                                    onClick={() => switchLeft(artcl)}
                                ><i className="fas fa-chevron-right"></i></button>
                            }

                            {idx !== 0 &&
                                <button
                                    className="btn_left btn_panel"
                                    onClick={() => switchRight(artcl)}
                                ><i className="fas fa-chevron-left"></i></button>
                            }

                            <button
                                className="del_article"
                                onClick={() => setToDelete(artcl)}
                            >
                                <i className="fas fa-xmark"></i>
                            </button>
                        </li>
                    ))}
                </ul>
            }

            {toDelete &&
                <ConfirmDelete
                    title="Supprimer un article"
                    itemName={toDelete.title_fr}
                    setToDelete={setToDelete}
                    _delete={deleteArticle}
                />
            }
        </div>
    );
}

export default Shop;